export default {
  PLATFORM_SELECTION: "platforms",
  GOAL_SELECTION: "goals",
  UPSELL: "trial",
  SERVICE_SELECTION: "services",
  RECOMMENDED_APPLETS: "applets",
}
